import styled from 'styled-components';

export const StyledMachineListTabMap = styled.div`
  &.machine-list__map-container {
    height: 560px;
  }
`;
